/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Text, Space, Conditional } from '@cashfree-intl/coherent';

import Analytics from 'utils/analytics';
import EVENTS from 'constants/analytics';

import { LOGIN_BANNER, LOGIN } from '../constants';

import CustomIcon from '../../../components/CustomIcons';
import { StyledHeader } from '../styled';

const LoginBanner = ({ formName }) => {
  const [displayArr, resetDisplay] = useState([]);
  const slideIndex = useRef(0);
  const timerRef = useRef(null);

  const updateDisplay = () => {
    const resultantArr = [];

    for (let i = 0; i < LOGIN_BANNER.length; i += 1) {
      if (i === slideIndex.current) resultantArr[i] = 'flex';
      else resultantArr[i] = 'none';
    }

    resetDisplay(resultantArr);
  };

  const showSlides = () => {
    if (formName === LOGIN) {
      updateDisplay();

      if (slideIndex.current === LOGIN_BANNER.length - 1)
        slideIndex.current = 0;
      else slideIndex.current += 1;

      if (LOGIN_BANNER.length > 1)
        timerRef.current = setTimeout(showSlides, 5000);
    }
  };

  useEffect(() => {
    showSlides();
    return () => {
      if (timerRef.current) {
        slideIndex.current = 0;
        clearTimeout(timerRef.current);
      }
    };
  }, [formName]);

  const goToSlide = slideNo => () => {
    if (LOGIN_BANNER.length === 1) return;
    slideIndex.current = slideNo;
    updateDisplay();
  };

  const viewDetails = link => () => {
    Analytics.trackEvent(EVENTS.KNOW_MORE_LOGIN, { link }, 'OB')();
    window.open(link);
  };

  return (
    <>
      {LOGIN_BANNER.map((banner, bannerNo) => (
        <Space
          direction="column"
          className={`login-banner ${banner.type}`}
          style={{
            display: displayArr[bannerNo],
          }}
          key={banner.type}
          onMouseEnter={() => {
            if (timerRef.current) clearTimeout(timerRef.current);
          }}
          onMouseLeave={() => {
            if (LOGIN_BANNER.length > 1)
              timerRef.current = setTimeout(showSlides, 2000);
          }}
        >
          <Conditional if={!!banner.heading}>
            <StyledHeader strong variant="h28" color="white">
              {banner.heading}
            </StyledHeader>
          </Conditional>
          <Conditional if={!!banner.description}>
            <Text variant="h16" color="white" className="mr-top-24 description">
              {banner.description}
            </Text>
          </Conditional>
          <Conditional if={!!banner.buttonText}>
            <Space alignItems="center" className="mr-top-24">
              <Text
                variant="h16"
                color="white"
                className="mr-right-8 pointer"
                onClick={viewDetails(banner.link)}
              >
                {banner.buttonText}
              </Text>
              <span className="pointer" onClick={viewDetails(banner.link)}>
                <CustomIcon componentName="FORWARD_ARROW" />
              </span>
            </Space>
          </Conditional>
          <Conditional if={banner.slideIndicator}>
            <Space className="mr-top-24">
              {LOGIN_BANNER.map((slide, slideNo) => (
                <div
                  className={`pointer slide ${
                    slideNo === bannerNo ? 'active' : 'disabled'
                  } ${slideNo !== LOGIN_BANNER.length - 1 ? 'mr-right-8' : ''}`}
                  key={slide.type}
                  onClick={goToSlide(slideNo)}
                />
              ))}
            </Space>
          </Conditional>
        </Space>
      ))}
    </>
  );
};

LoginBanner.propTypes = {
  formName: PropTypes.string.isRequired,
};

export default LoginBanner;
